var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RadioGroup", {
        attrs: { options: _vm.typeOptions },
        on: { input: _vm.emitChangeEvent },
        model: {
          value: _vm.type,
          callback: function($$v) {
            _vm.type = $$v
          },
          expression: "type"
        }
      }),
      _vm._v(" "),
      _vm.dateEligible
        ? _c("DatePickerCalendar", {
            attrs: { "force-min-date": new Date(), "years-in-future": 2 },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.date,
              callback: function($$v) {
                _vm.date = $$v
              },
              expression: "date"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }